import type { InvoiceOffer } from '@klear/invoice-offer/invoice-offer'
import type { OrderEventOrderEventType } from '@klear/order-event/constants'

export type OrderEventRef = {
  id: number
  orderId: number
  traderId: number
  type: OrderEventOrderEventType
}

export function orderEventRef(input: OrderEventRef): OrderEventRef {
  return input
}

export function orderEventRefFromOffer(
  offer: Pick<InvoiceOffer, 'id' | 'orderId' | 'traderId' | 'type'>
): OrderEventRef {
  return {
    id: offer.id,
    orderId: offer.orderId,
    traderId: offer.traderId,
    type: offer.type
  }
}
